import { types } from "./types/types";

const initialState = {
    departamentos: null,
    checkingDepartamentos: true,
    sucursales: null,
    checkingSucursales: true,
    puestos: null,
    checkingPuestos: true,
    busqueda: null,
    checkingBusqueda: true,
}

export const empleado = (state = initialState, action) => {
    switch (action.type) {
        case types.empSetPuestos:
            return {
                ...state,
                puestos: action.payload,
                checkingPuestos: false
            }
        case types.empSetDepartamentos:
            return {
                ...state,
                departamentos: action.payload,
                checkingDepartamentos: false
            }
        case types.empSetSucursal:
            return {
                ...state,
                sucursales: action.payload,
                checkingSucursales: false
            }
        case types.empSetBusqueda:
            return {
                ...state,
                busqueda: action.payload,
                checkingBusqueda: false
            }
        default:
            return state;

    }
}
